export default function gmapInit( mapSelector ) {

  const mapElem = document.querySelector( mapSelector ) || false;

  const $markers = mapElem.querySelectorAll('.marker') || false;

  const mapArgs = {
    zoom        : parseInt( mapElem.dataset.zoom ) || 16,
    scrollwheel: false,
    mapTypeControl: false,
    draggable: true,
    streetViewControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [{
      featureType: "all",
      elementType: "all",
      stylers: [{ saturation: -100 }]
    }]
  };
  const map = new google.maps.Map( mapElem, mapArgs );

  map.markers = [];
  $markers.forEach( (marker) => {
    initMarker( marker, map );
  });

  centerMap( map );

  return map;
}

function initMarker( markerElem, map ) {

  const lat = markerElem.dataset.lat;
  const lng = markerElem.dataset.lng;
  const latLng = {
    lat: parseFloat( lat ),
    lng: parseFloat( lng )
  };

  const marker = new google.maps.Marker({
    position : latLng,
    map: map
  });

  map.markers.push( marker );

  if( markerElem.innerHTML ){

    const infowindow = new google.maps.InfoWindow({
      content: marker.innerHTML
    });

    // Show info window when marker is clicked.
    google.maps.event.addListener(marker, 'click', function() {
      infowindow.open( map, marker );
    });
  }

}

function centerMap( map ) {

  const bounds = new google.maps.LatLngBounds();
  map.markers.forEach(function( marker ){
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng()
    });
  });

  if( map.markers.length == 1 ){
    map.setCenter( bounds.getCenter() );

  } else{
    map.fitBounds( bounds );
  }
}


// WEBPACK FOOTER //
// app/scripts/components/map.js